<template>
  <v-container class="container">
    <div class="diagonal"></div>
    <forget-pass v-if="forget" @forgetEmit="closeWindow" />
    <snackbar :text="text" :status="status" v-if="text" />

    <v-layout wrap row class="box">
      <v-flex xs12 sm6>
        <img
          src="@/assets/dd.jpeg"
          alt="dd"
          class="elevation-10"
          style="width: 100%; margin: 11rem auto 0 -22%"
        />
      </v-flex>
      <v-flex xs12 sm6 style="padding: 1rem 3rem">
        <img class="logo" alt="logo" src="@/assets/uv-logo-full.png" />

        <h1>Welcome</h1>

        <form onsubmit="return ">
          <input type="text" v-model="username" placeholder="Email" />
          <input
            type="password"
            v-model="password"
            placeholder="Password"
            @keyup.enter="login"
          />
          <p v-if="error" class="error-text">{{ error }}</p>

          <a @click="openWindow">Forgot password?</a>
          <v-btn class="sign-btn" v-if="loading">
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </v-btn>
          <v-btn class="sign-btn" v-else @click="login">Sign In</v-btn>
          <p>{{ errnotif }}</p>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import simpleCrypto from '@/helpers/crypto'
import axios from '@/helpers/axios'
import ForgetPass from '@/components/ForgetPass'
import Snackbar from '@/components/Snackbar.vue'

export default {
  name: 'Login',
  components: {
    ForgetPass,
    Snackbar
  },
  data () {
    return {
      username: '',
      password: '',
      forget: false,
      errnotif: null,
      loading: false,
      text: null,
      status: null,
      hide: false,
      error: ''
    }
  },
  methods: {
    openWindow () {
      this.forget = true
      this.errnotif = null
    },
    closeWindow (val) {
      this.forget = false
      if (val) this.text = 'Success Change Password'
      this.status = 'success'
      this.errnotif = null
    },
    login () {
      this.loading = true
      let dataBody = {
        username: this.username,
        password: this.password
      }

      let reqBody = Object.keys(dataBody)
        .map(function (key) {
          return (
            encodeURIComponent(key) + '=' + encodeURIComponent(dataBody[key])
          )
        })
        .join('&')

      let loginUrl = '/login'

      axios
        .post(loginUrl, reqBody)
        .then((response) => {
          if (response.data.code === 'SSR001') {
            let rawappid = response.data.data.app_id
            let appid = simpleCrypto.encrypt(rawappid)
            let rawappkey = response.data.data.app_key
            let appkey = simpleCrypto.encrypt(rawappkey)
            let rawapidoc = response.data.data.api_doc
            let apidoc = simpleCrypto.encrypt(rawapidoc)
            let accessApi = simpleCrypto.encrypt(response.data.data.access_api)
            let username = simpleCrypto.encrypt(response.data.data.nama_client)
            let receiver = simpleCrypto.encrypt(
              response.data.data.account_username
            )
            let showRedemption = simpleCrypto.encrypt(response.data.data.show_redeemption_status)
            let idClient = simpleCrypto.encrypt(response.data.data.id_client)
            let logoClient = simpleCrypto.encrypt(response.data.data.logo_client)
            let guideTopUp = localStorage.getItem('guideTopUp')
              ? localStorage.getItem('guideTopUp')
              : 'unread'
            let tokenUrl = `/accesstoken?app_id=${rawappid}&app_key=${rawappkey}`
            axios
              .get(tokenUrl)
              .then((response) => {
                if (response.data.token) {
                  localStorage.setItem('_pid', appid)
                  localStorage.setItem('_pky', appkey)
                  localStorage.setItem('_idc', apidoc)
                  localStorage.setItem('as_api', accessApi)
                  localStorage.setItem('_ict', idClient)
                  localStorage.setItem('t_tk', response.data.token)
                  localStorage.setItem('u_nm', username)
                  localStorage.setItem('e_rcv', receiver)
                  localStorage.setItem('lg_cl', logoClient)
                  localStorage.setItem(
                    'xrd',
                    new Date(response.data.expired_time).getTime()
                  )
                  localStorage.setItem('guideTopUp', guideTopUp)
                  localStorage.setItem('shw_rdmptn', showRedemption)
                }
                window.location.reload()
                // This catch below allows you to only avoid the error displaying, because browser thinks the exception was handled.
                this.$router.push('/').catch(() => {})
                this.loading = false
              })
              .catch((error) => {
                this.errnotif = error.response.data.message
                setTimeout(function () {
                  this.errnotif = null
                }, 5000)
              })
          } else {
            this.error = response.data.message
            setTimeout(() => {
              this.error = ''
            }, 3000)
          }
        })
        .catch((error) => {
          this.errnotif = error.response.data.message
          setTimeout(function () {
            this.errnotif = null
          }, 5000)
        })
      this.loading = false
    }
  },
  watch: {
    text () {
      setTimeout(() => {
        this.text = null
        this.status = null
      }, 5000)
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.box {
  position: relative;
  min-height: 40rem;
  max-width: 80%;
  margin: 10% auto;
  border: 1px solid #eeeeee;
  box-shadow: 0 0 8px 2px #ccc;
}

img.logo {
  display: block;
  margin: 0 auto;
  width: 30%;
  padding: 30px 0px;
}

h1 {
  text-align: center;
  font-weight: 100;
  font-size: 24px;
  text-transform: uppercase;
  letter-spacing: 10px;
  margin-bottom: 20px;
}

a {
  text-decoration: none;
  color: inherit;
}

input[type='text'] {
  padding: 16px;
  border-radius: 4px 4px 0 0;
  background: transparent;
  border: 1px solid #cfd0d1;
  display: block;
  margin: 0 auto;
  width: 75%;
}

input[type='password'] {
  padding: 16px;
  border-radius: 0 0 4px 4px;
  border: 1px solid #cfd0d1;
  border-top: none;
  background: transparent;
  display: block;
  margin: 0 auto;
  margin-bottom: 12px;
  width: 75%;
}

.sign-btn {
  padding: 14px !important;
  border-radius: 50px;
  background: #00aa4b !important;
  border: none;
  box-shadow: 0 8px 15px 0 rgba(18, 151, 147, 0.4) !important;
  display: flex;
  margin: 1rem auto;
  width: 80%;
  height: auto;
  color: white !important;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1.05px;
}

form a {
  display: block;
  width: 80%;
  margin: 0 auto;
  margin-bottom: 28px;
  text-align: right;
  color: #4dbd77;
}

div.signup {
  text-align: center;
  margin-top: 7rem;
}

div.signup p {
  padding: 0px;
  margin: 4px 0px;
}

div.signup a {
  color: darkseagreen;
}

.diagonal {
  top: 0;
  left: 0;
}

.diagonal::after {
  content: '';
  display: block;
  width: 12%;
  height: 100%;
  background: #479a46;
  position: fixed;
  left: 20rem;
  top: 0;
  transform: skewX(35deg);
  z-index: 0;
}

.error-text {
  color: #E02020;
  width: 75%;
  margin: 0 auto;
  text-align: left;
  font-size: 12px;
  margin-bottom: 1rem;
}
</style>
